import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import logoOuraTrust from "@/assets/logo-ouratrust-v2.png";
import { useLanguage } from "@/hooks/useLanguage";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        {/* Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <Link to="/">
              <img src={logoOuraTrust} alt="OuraTrust" className="h-7 object-contain brightness-0 invert mb-4" width={185} height={28} />
            </Link>
            <p className="text-slate-400 text-sm max-w-sm">
              {t.footerTagline}
            </p>
            <p className="text-xs text-primary font-bold mt-4 flex items-center gap-1.5">
              <Shield size={14} />
              {t.footerCompliance}
            </p>
          </div>
          
          {/* Product Column */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t.resources}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/how-it-works" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.footerHowItWorks}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.footerPricing}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.footerAbout}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.blog}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.contact}
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Legal Column */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t.footerLegal}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.privacyPolicy}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.termsOfService}
                </Link>
              </li>
              <li>
                <Link to="/legal-notice" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.legalMentions}
                </Link>
              </li>
              <li>
                <Link to="/data-deletion" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t.dataDeletion}
                </Link>
              </li>
              <li>
                <Link to="/google-data-usage" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Google API Data Usage
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Compliance Notice */}
        <div className="py-4 border-t border-slate-800 text-center space-y-2">
          <p className="text-xs text-slate-500">
            {t.footerApiNotice}
          </p>
          <p className="text-[10px] text-slate-600 max-w-2xl mx-auto">
            {t.footerComplianceDisclaimer}
          </p>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-4 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-xs text-slate-500">{t.footerCopyright}</span>
          <p className="text-sm text-slate-400">{t.contact}: support@ouratrust.com</p>
        </div>
      </div>
    </footer>
  );
};
